import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import i18n from "i18next";
import { supabase } from "@/integrations/supabase/client";

const STORAGE_KEY = "newsletter_visit_logged";

/**
 * Logs a visit when the user arrives from a newsletter link (utm_source=newsletter).
 * One record per campaign+path per browser session.
 */
export const NewsletterTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const source = params.get("utm_source");
    // Brevo rewrites links and sets utm_source=brevo, own links use utm_source=newsletter
    if (!source || (source !== "newsletter" && source !== "brevo")) return;


    const campaign = params.get("utm_campaign") ?? "unknown";
    const key = `${campaign}|${location.pathname}`;
    try {
      const logged = JSON.parse(sessionStorage.getItem(STORAGE_KEY) ?? "[]") as string[];
      if (logged.includes(key)) return;
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...logged, key]));
    } catch {
      /* ignore storage errors */
    }

    void supabase
      .from("newsletter_visits")
      .insert({
        campaign,
        source,
        medium: params.get("utm_medium"),
        content: params.get("utm_content"),
        path: location.pathname,
        lang: i18n.language?.slice(0, 2) ?? null,
      })
      .then(() => undefined);
  }, [location.pathname, location.search]);

  return null;
};
